// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"809a0ca1","869":"13cac517","936":"33fa042f"}[chunkId] + ".chunk.js";
};